<template>
  <draggable :list="group.children" item-key="name" @change="changeDrag($event, group.id)">
    <template #item="{ element, index }">
      <TypificationItem
        :key="index"
        :index="index"
        :item="element"
        :parent="group"
        :name="`Resultado ${index + 1}`"
        :total="totalResults"
        type="result"
        @updateTree="updateTree"
        @onToggleStatus="
          handleToggleStatus($event, element, `Resultado ${index + 1}`, group.id, element.id)
        "
      >
        <template #edit="{ hideMoreOptions }">
          <MotiveAdd
            :itemgroup="group"
            :itemresult="element"
            @push="handlePush($event, element.children)"
            @click="hideMoreOptions"
          />

          <TypificationForm
            :item="element"
            :disabled="haveForm(element)"
            @onChange="handleChange($event, element)"
            @updateTree="updateTree"
            @click="hideMoreOptions"
          />

          <ResultEdit
            :itemgroup="group"
            :item="element"
            @change="handleChange($event, element)"
            @click="hideMoreOptions"
          />

          <a-button
            type="text"
            @click="
              handleDeleteItem($event, element, `Resultado ${index + 1}`, group.id, element.id);
              hideMoreOptions();
            "
          >
            <template #icon>
              <DeleteOutlined />
            </template>

            Eliminar resultado
          </a-button>
        </template>
        <TypificationMotive
          :result="element"
          :group="group"
          @onChange="handleChange"
          @onPush="handlePush"
          @onDrag="changeDrag"
          @onDelete="handleDeleteItem"
          @onToggleStatus="handleToggleStatus"
          @updateTree="updateTree"
        />
      </TypificationItem>
    </template>
  </draggable>
</template>

<script>
import TypificationItem from "@/app/entities/components/picker/TypificationItem.vue";
import ResultEdit from "@/app/entities/components/drawers/typifications/TypificationResultEdit.vue";
import MotiveAdd from "@/app/entities/components/drawers/typifications/TypificationMotive.vue";
import TypificationForm from "@/app/entities/components/modals/typifications/TypificationForm.vue";
import TypificationMotive from "@/app/entities/components/picker/TypificationMotive.vue";
import { defineComponent } from "vue";
import { DeleteOutlined } from "@ant-design/icons-vue";
import draggable from "vuedraggable";
export default defineComponent({
  components: {
    DeleteOutlined,
    TypificationItem,
    ResultEdit,
    MotiveAdd,
    TypificationMotive,
    draggable,
    TypificationForm,
  },
  props: {
    group: {
      required: true,
      type: Object,
    },
  },
  computed: {
    totalResults() {
      return this.group.children.length;
    },
  },
  methods: {
    changeDrag($event, ...args) {
      this.$emit("onDrag", $event, ...args);
    },
    handleChange(newItem, oldItem) {
      this.$emit("onChange", newItem, oldItem);
    },
    handlePush(item, array) {
      this.$emit("onPush", item, array);
    },
    handleDeleteItem(...args) {
      this.$emit("onDelete", ...args);
    },
    handleToggleStatus(...args) {
      this.$emit("onToggleStatus", ...args);
    },
    updateTree() {
      this.$emit("updateTree");
    },
    haveForm(element) {
      if (element.form_id != null) {
        return false;
      } else {
        let haveForm = false;
        element.children.forEach((motive) => {
          if (motive.children.find((submotive) => submotive.form_id != null)) haveForm = true;
          if (motive.form_id != null) haveForm = true;
        });
        return haveForm;
      }
    },
  },
});
</script>

<style></style>
